export default {
	DEFAULT: "default",
	SCROLLABLE: "scrollable",
	TRUNCATED: "truncated",
};
